import { useState, useEffect } from 'react';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import { getImageAuthURLAsync } from 'components/main/common/utils';

/**
 * Custom hook for managing portal profile data
 * @param {number} categoryId - Active category ID
 * @returns {Object} Profile state and methods
 */
export const usePortalProfile = (categoryId) => {
  const [profile, setProfile] = useState(null);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [languageId, setLanguageId] = useState(0);

  const loadProfileByCategory = async (id) => {
    if (!id) {
      setProfile(null);
      setShowError(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    setShowError(false);

    try {
      const storedProfile = Storages.MainStorage.getItem(StorageKeys.Keys.PROFILE + id);
      const currentLanguageId = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGEID);
      setLanguageId(currentLanguageId);

      if (storedProfile) {
        const locale_var = storedProfile.profile_desc_locale.find(
          (local) => local.language_id === currentLanguageId
        );

        if (locale_var) {
          const processedProfile = {
            image: await getImageAuthURLAsync(storedProfile.image),
            category_title: storedProfile.category_title,
            locale_description: locale_var.locale_description,
            raw: storedProfile, // Keep reference to original data if needed
          };

          setProfile(processedProfile);
          setShowError(false);
          setLoading(false);
        } else {
          setProfile(null);
          setShowError(true);
          setLoading(false);
        }
      } else {
        setProfile(null);
        setShowError(true);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error loading profile:', error);
      setProfile(null);
      setShowError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (categoryId) {
      loadProfileByCategory(categoryId);
    }
  }, [categoryId]);

  return {
    profile,
    showError,
    loading,
    languageId,
    refreshProfile: () => loadProfileByCategory(categoryId),
  };
};
